/* Developed by Guilherme Montenegro - www.guimontenegrodev.com */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ms-popup-form').forEach((container) => {
    if (container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    const sectionId = container.dataset.sectionId;
    const triggerId = container.dataset.triggerId;

    const form = container.querySelector('form');
    const closeBtn = container.querySelector('.ms-popup-form__close-button');
    const closeIcon = container.querySelector('.ms-popup-form__close-icon');
    const redirectUrl = container.dataset.redirectUrl;

    const autoOpen = container.dataset.autoOpen === 'true';
    const autoOpenIn = parseInt(container.dataset.autoOpenIn) || 0;
    const autoReopenIn = parseInt(container.dataset.autoReopenIn) || 0;

    const storageKey = `ms_popup_shown_${sectionId}`;
    const submittedKey = `ms_popup_submitted_${sectionId}`;

    const msg = {
      success: container.dataset.successText,
      submitError: 'Ocorreu um erro, por favor, tente novamente mais tarde',
      required: 'Este campo é obrigatório',
      email: 'O e-mail deve conter o caractere @ e um domínio válido',
      phone: 'O telefone deve conter apenas números, símbolos + e -, e espaços vazios',
    };

    function openPopup() {
      const n = (parseInt(document.documentElement.dataset.msScrollLocks || '0', 10) || 0) + 1;
      document.documentElement.dataset.msScrollLocks = String(n);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      container.style.display = 'flex';
      localStorage.setItem(storageKey, Date.now().toString());
    }

    function closePopup() {
      const n = Math.max(0, (parseInt(document.documentElement.dataset.msScrollLocks || '0', 10) || 0) - 1);
      document.documentElement.dataset.msScrollLocks = String(n);
      if (n === 0) {
        document.body.style.overflow = 'unset';
        document.documentElement.style.overflow = 'unset';
      }
      container.style.display = 'none';
    }

    function shouldAutoOpen() {
      if (!autoOpen) return false;
      const submitted = localStorage.getItem(submittedKey);
      if (submitted) return false;
      const lastShown = localStorage.getItem(storageKey);
      if (!lastShown) return true;
      if (autoReopenIn === 0) return false;
      const diffDays = (Date.now() - parseInt(lastShown, 10)) / (1000 * 60 * 60 * 24);
      return diffDays >= autoReopenIn;
    }

    if (triggerId) {
      const cleanId = triggerId.replace(/^#/, '');
      const targets = Array.from(document.querySelectorAll(`a[href="#${cleanId}"], #${cleanId}`));
      targets.forEach((t) => {
        if (t.dataset.bound === 'true') return;
        t.dataset.bound = 'true';
        t.addEventListener('click', (e) => {
          e.preventDefault();
          openPopup();
        });
      });
    }

    if (shouldAutoOpen()) {
      const delay = autoOpenIn > 0 ? autoOpenIn * 1000 : 0;
      setTimeout(() => openPopup(), delay);
    }

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (closeIcon) closeIcon.addEventListener('click', closePopup);

    if (!form) return;
    if (form.dataset.bound === 'true') return;
    form.dataset.bound = 'true';

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      form.querySelectorAll('.ms-popup-form__field-error, .ms-popup-form__success, .ms-popup-form__error').forEach((el) => el.remove());

      let valid = true;

      form.querySelectorAll('[required]').forEach((field) => {
        if (!field.value.trim()) {
          valid = false;
          const err = document.createElement('div');
          err.className = 'gmdev-popup-form__field-error paragraph';
          err.textContent = msg.required;
          field.insertAdjacentElement('afterend', err);
        }
      });

      const emailInput = form.querySelector('input[type="email"]');
      if (emailInput && emailInput.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value)) {
        valid = false;
        const err = document.createElement('div');
        err.className = 'gmdev-popup-form__field-error paragraph';
        err.textContent = msg.email;
        emailInput.insertAdjacentElement('afterend', err);
      }

      const phoneInput = form.querySelector('input[type="tel"]');
      if (phoneInput && phoneInput.value && !/^[\d+\s-]+$/.test(phoneInput.value)) {
        valid = false;
        const err = document.createElement('div');
        err.className = 'gmdev-popup-form__field-error paragraph';
        err.textContent = msg.phone;
        phoneInput.insertAdjacentElement('afterend', err);
      }

      if (!valid) return;

      const data = new FormData(form);
      const controls = Array.from(form.querySelectorAll('input, button, select, textarea'));
      const submitButton = form.querySelector('.ms-popup-form__submit-button');
      const originalText = submitButton.textContent;
      controls.forEach((c) => (c.disabled = true));
      submitButton.textContent = 'Enviando...';
      if (closeBtn) closeBtn.textContent = 'Fechar';

      try {
        const endpoint = form.getAttribute('data-endpoint') || form.action || '';
        const res = await fetch(endpoint, { method: 'POST', body: data, mode: 'cors' });
        if (!res.ok) throw new Error();
        const feedback = document.createElement('p');
        feedback.className = 'h6 ms-popup-form__success';
        feedback.textContent = msg.success;
        submitButton.insertAdjacentElement('afterend', feedback);
        submitButton.textContent = originalText;
        localStorage.setItem(submittedKey, 'true');
        if (redirectUrl) setTimeout(() => (window.location.href = redirectUrl), 1500);
      } catch {
        const feedback = document.createElement('p');
        feedback.className = 'h6 ms-popup-form__error';
        feedback.textContent = msg.submitError;
        submitButton.insertAdjacentElement('afterend', feedback);
        submitButton.textContent = originalText;
        controls.forEach((c) => (c.disabled = false));
      }
    });
  });
});